import { CAMPAIGN_TYPES, type CampaignType } from "../../src/domain/campaignTypes";

type CampaignTypePickerProps = {
  onSelect: (campaignType: CampaignType) => void;
};

export function CampaignTypePicker({ onSelect }: CampaignTypePickerProps) {
  return (
    <section className="campaign-type-picker" aria-labelledby="campaign-type-heading">
      <div className="campaign-type-intro">
        <span className="step-label">Step 1 of 2</span>
        <h2 id="campaign-type-heading">Choose a campaign type</h2>
        <p>Each campaign type has its own trigger, offers, and settings. You cannot change the type after the campaign is created.</p>
      </div>
      <div className="campaign-type-grid">
        {CAMPAIGN_TYPES.map((campaignType) => (
          <button
            className="campaign-type-card"
            key={campaignType.id}
            type="button"
            onClick={() => onSelect(campaignType.id)}
          >
            <span className="campaign-type-icon" aria-hidden="true">
              {campaignType.supportsServices ? "▤" : "+"}
            </span>
            <span className="campaign-type-content">
              <strong>{campaignType.title}</strong>
              <small>{campaignType.description}</small>
              <span className="campaign-type-meta">
                <span>{campaignType.placementLabel}</span>
                <span>{campaignType.presentationLabel}</span>
              </span>
              <span className="campaign-type-action">Choose type →</span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
